// extracted by mini-css-extract-plugin
export default {"tableDiv":"primeTable_tableDiv__Avjsw","noData":"primeTable_noData__UkQY7","loader":"primeTable_loader__Pvj2N"};